import { useUnsafeEffect } from "@wags/tanstack-start/react";
import { type ReactNode, useRef, useState } from "react";

const NEAR_VIEWPORT_MARGIN = "200px";

export function ReactTreeWhenNear({
    children,
    keepServerMarkup = false,
}: {
    children: ReactNode;
    keepServerMarkup?: boolean;
}) {
    const [live, setLive] = useState(false);
    const nodeRef = useRef<HTMLDivElement | null>(null);

    useUnsafeEffect(() => {
        const node = nodeRef.current;
        if (!node || live) return;
        if (typeof IntersectionObserver !== "function") {
            setLive(true);
            return;
        }
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry?.isIntersecting) setLive(true);
            },
            { rootMargin: NEAR_VIEWPORT_MARGIN },
        );
        observer.observe(node);
        return () => observer.disconnect();
    }, [live]);

    if (live || (keepServerMarkup && typeof window === "undefined")) {
        return <div ref={nodeRef}>{children}</div>;
    }
    if (keepServerMarkup) {
        return (
            <div
                ref={nodeRef}
                suppressHydrationWarning
                dangerouslySetInnerHTML={{ __html: "" }}
            />
        );
    }
    return <div ref={nodeRef} />;
}
